import { whySwitch } from '@/lib/marketing/content'

export function WhySwitch() {
  return (
    <section className="py-16 sm:py-24">
      <div className="max-w-[960px] mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block px-3 py-1 rounded-full bg-[#71ED7F]/10 border border-[#71ED7F]/20 text-[#71ED7F] text-xs font-semibold uppercase tracking-wider mb-4">
            {whySwitch.badge}
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium font-display mb-4">
            <span className="text-white">{whySwitch.headline}</span>
            <br />
            <span className="text-[#71ED7F]">{whySwitch.headlineAccent}</span>
          </h2>
          <p className="text-white/50 max-w-lg mx-auto text-sm sm:text-base">
            {whySwitch.subheadline}
          </p>
        </div>

        {/* 3-Step Timeline */}
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {whySwitch.steps.map((step, i) => (
            <div key={i} className="relative">
              {/* Connector line (desktop only) */}
              {i < whySwitch.steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[calc(50%+40px)] right-0 h-px bg-gradient-to-r from-[#71ED7F]/30 to-transparent" />
              )}

              <div className="bg-[#001716] rounded-2xl border border-[#E4FFE7]/[0.08] p-6 h-full relative group hover:border-[#71ED7F]/20 transition-colors">
                {/* Step number */}
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-xl bg-[#71ED7F]/10 border border-[#71ED7F]/20 flex items-center justify-center">
                    <span className="text-[#71ED7F] text-sm font-semibold">{step.number}</span>
                  </div>
                  <h3 className="text-base sm:text-lg font-semibold text-white">{step.title}</h3>
                </div>
                <p className="text-white/50 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Go-Live Checklist Card */}
        <div className="max-w-md mx-auto">
          <div className="relative">
            {/* Glow */}
            <div className="absolute -inset-3 bg-[#71ED7F]/[0.06] rounded-3xl blur-2xl pointer-events-none" />

            <div className="relative bg-[#001716] rounded-2xl border border-[#71ED7F]/20 p-6 shadow-[0_8px_32px_-8px_rgba(0,0,0,0.4)]">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-8 h-8 rounded-lg bg-[#71ED7F]/20 flex items-center justify-center">
                  <svg className="w-4 h-4 text-[#71ED7F]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                  </svg>
                </div>
                <h4 className="text-base font-semibold text-white">{whySwitch.checklist.title}</h4>
              </div>

              <div className="space-y-3">
                {whySwitch.checklist.items.map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-md bg-[#71ED7F]/10 border border-[#71ED7F]/30 flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-[#71ED7F]" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-sm text-white/70">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href="#demo"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-transparent border border-[#E4FFE7]/10 text-white/70 text-sm font-medium hover:bg-white/5 hover:border-white/15 transition-all"
          >
            {whySwitch.cta}
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  )
}
